import React from 'react';
import { Grid } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import DyanamicDropdown from 'components/Elements/DynamicDropdown';
import { useFilters } from '../FilterContext';
import { useRiskRatings } from './hooks/useRiskRatings';
import { useFilterInitialization } from './hooks/useFilterInitialization';
import { SHOW_ALL_OPTION } from '../constants';

export const RiskRatingFilter = () => {
  const { filterValues, updateFilter, isShowAll } = useFilters();
  const showAllEnabled = isShowAll('riskRatings');
  const riskRatings = useRiskRatings(showAllEnabled);

  // Clean, declarative initialization with URL persistence
  useFilterInitialization('riskRatings', riskRatings, {
    waitForData: true,
    getDefaultValue: () => SHOW_ALL_OPTION,
    getParams: (item) => ({ defectRiskRatingId: item.id })
  });

  if (!filterValues.riskRatings) {
    return null;
  } 

  return (
    <Grid item lg={3} md={6} xs={12}>
      <DyanamicDropdown
        dataSource={riskRatings}
        columns={[{ name: 'name', id: 1 }]}
        showHeader={false}
        width="100%"
        placeholder="Select Risk Rating"
        onChange={item => updateFilter('riskRatings', item, { defectRiskRatingId: item.id })}
        selectdValueToshow="name"
        selectedValue={filterValues.riskRatings?.value}
        label="Filter by Risk Rating"
        icon={<FilterListIcon style={{ color: 'rgb(48,122,215)' }} />}
        required={false}
        showBorderColor
      />
    </Grid>
  );
}; 
